(function () {
  if (!window.customElements) return;

  function patchSmoothVariantSwitch() {
    var ProductHotReload = window.customElements.get('product-hot-reload');
    if (!ProductHotReload || ProductHotReload.prototype.smoothVariantSwitchPatched) return;

    var prototype = ProductHotReload.prototype;
    var originalUpdate = prototype.updateProductWithTransition;

  prototype.smoothVariantSwitchPatched = true;

  prototype.showLoadingState = function () {
    if (this.loadingTimeout) clearTimeout(this.loadingTimeout);
    this.loadingTimeout = setTimeout(function () {
      this.setAttribute('aria-busy', 'true');
    }.bind(this), 200);
  };

  prototype.hideLoadingState = function () {
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = null;
    }
    this.classList.remove('product-hot-reload--loading');
    this.removeAttribute('aria-busy');
  };

  prototype.getProductPath = function (productUrl) {
    return new URL(productUrl || this.dataset.productUrl, window.location.origin).pathname.replace(/\/$/, '');
  };

  prototype.syncVariantControls = function (updatedRoot) {
    var updatedInputs = Array.from(updatedRoot.querySelectorAll('[data-option-value-id]'));

    this.querySelectorAll('input[data-option-value-id]').forEach(function (currentInput) {
      var updatedInput = updatedInputs.find(function (input) {
        return input.dataset.optionValueId === currentInput.dataset.optionValueId && input.name === currentInput.name;
      });
      if (!updatedInput) return;

      var currentLabel = currentInput.closest('label');
      var updatedLabel = updatedInput.closest('label');
      if (currentLabel && updatedLabel) currentLabel.replaceWith(updatedLabel.cloneNode(true));
    });

    this.querySelectorAll('select[data-product-hot-reload-trigger]').forEach(function (currentSelect) {
      var updatedSelect = updatedRoot.querySelector('[id="' + currentSelect.id + '"]');
      if (!updatedSelect) return;
      currentSelect.innerHTML = updatedSelect.innerHTML;
      currentSelect.value = updatedSelect.value;
    });

    this.querySelectorAll('[data-selected-option-position]').forEach(function (currentLabel) {
      var position = currentLabel.dataset.selectedOptionPosition;
      var updatedLabel = updatedRoot.querySelector('[data-selected-option-position="' + position + '"]');
      if (updatedLabel) currentLabel.textContent = updatedLabel.textContent;
    });
  };

  prototype.syncElement = function (currentElement, updatedElement) {
    Array.from(currentElement.attributes).forEach(function (attribute) {
      if (!updatedElement.hasAttribute(attribute.name)) currentElement.removeAttribute(attribute.name);
    });

    Array.from(updatedElement.attributes).forEach(function (attribute) {
      if (currentElement.getAttribute(attribute.name) !== attribute.value) {
        currentElement.setAttribute(attribute.name, attribute.value);
      }
    });

    var currentChildren = Array.from(currentElement.childNodes);
    var updatedChildren = Array.from(updatedElement.childNodes);
    var childCount = Math.max(currentChildren.length, updatedChildren.length);

    for (var index = 0; index < childCount; index += 1) {
      var currentChild = currentChildren[index];
      var updatedChild = updatedChildren[index];

      if (!updatedChild && currentChild) {
        currentChild.remove();
        continue;
      }

      if (!currentChild && updatedChild) {
        currentElement.appendChild(updatedChild.cloneNode(true));
        continue;
      }

      var sameElement = currentChild.nodeType === 1 && updatedChild.nodeType === 1 && currentChild.tagName === updatedChild.tagName;
      var sameTextNode = currentChild.nodeType === 3 && updatedChild.nodeType === 3;

      if (sameElement) {
        this.syncElement(currentChild, updatedChild);
      } else if (sameTextNode) {
        if (currentChild.nodeValue !== updatedChild.nodeValue) currentChild.nodeValue = updatedChild.nodeValue;
      } else {
        currentChild.replaceWith(updatedChild.cloneNode(true));
      }
    }
  };

  prototype.syncBuyButtons = function (currentBlock, updatedBlock) {
    var currentButton = currentBlock.querySelector('button[type="submit"], input[type="submit"]');
    var updatedButton = updatedBlock.querySelector('button[type="submit"], input[type="submit"]');

    if (currentButton && updatedButton) this.syncElement(currentButton, updatedButton);
  };

  prototype.getVariantChoice = function (control) {
    if (!control) return null;

    if (control.tagName === 'SELECT') {
      return control.options[control.selectedIndex] || null;
    }

    return control;
  };

  prototype.getVariantMediaId = function (control) {
    var choice = this.getVariantChoice(control);
    return choice && choice.dataset.variantMediaId;
  };

  prototype.hydrateSlideImage = function (slide) {
    var image = slide && slide.querySelector('.overlay-lightbox__trigger > img');
    if (!image || !image.dataset.responsiveSrcset) return;

    image.srcset = image.dataset.responsiveSrcset;
    image.sizes = image.dataset.responsiveSizes || '100vw';
    image.src = image.dataset.responsiveSrc;
    delete image.dataset.responsiveSrcset;
    delete image.dataset.responsiveSizes;
    delete image.dataset.responsiveSrc;
  };

  prototype.preloadMediaImage = function (media) {
    var image = media && media.querySelector('img');
    if (!image) return Promise.resolve();

    var source = image.dataset.responsiveSrc || image.getAttribute('src');
    var sourceSet = image.dataset.responsiveSrcset || image.getAttribute('srcset');
    var sizes = image.dataset.responsiveSizes || image.getAttribute('sizes') || '100vw';
    if (!source && !sourceSet) return Promise.resolve();

    return new Promise(function (resolve) {
      var preloader = new Image();
      var settled = false;
      var timeout;

      var finish = function () {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        resolve();
      };

      preloader.onload = finish;
      preloader.onerror = finish;
      preloader.sizes = sizes;
      if (sourceSet) preloader.srcset = sourceSet;
      if (source) preloader.src = source;
      timeout = setTimeout(finish, 4000);

      if (preloader.complete) finish();
    });
  };

  prototype.getVariantContent = function (control) {
    var requestUrl = this.buildRequestUrl(control);

    if (this.cache.has(requestUrl)) return Promise.resolve(this.cache.get(requestUrl));
    if (this.activeRequests.has(requestUrl)) return this.activeRequests.get(requestUrl);
    return this.fetchContent(requestUrl);
  };

  prototype.warmVariantChoice = function (control) {
    if (!control || !control.hasAttribute('data-product-hot-reload-trigger')) return;
    if (control.type === 'radio' && control.checked) return;

    var mediaId = this.getVariantMediaId(control);
    var gallery = this.querySelector('media-gallery');
    var localMedia = mediaId && gallery && gallery.querySelector('.media-gallery__slide[data-media-id="' + mediaId + '"]');

    if (!this.mediaWarmups) this.mediaWarmups = new Map();

    if (localMedia && !this.mediaWarmups.has(String(mediaId))) {
      var mediaWarmup = this.preloadMediaImage(localMedia).then(function () {
        this.hydrateSlideImage(localMedia);
      }.bind(this));
      this.mediaWarmups.set(String(mediaId), mediaWarmup);
    }

    this.getVariantContent(control).then(function (html) {
      if (localMedia) return;

      var updatedRoot = html.getElementById(this.id);
      var updatedMedia = updatedRoot && updatedRoot.querySelector('media-gallery .media-gallery__slide--active[data-media-id]');
      if (!updatedMedia) return;

      var updatedMediaId = String(updatedMedia.dataset.mediaId || '');
      if (this.mediaWarmups.has(updatedMediaId)) return;

      var remoteWarmup = this.preloadMediaImage(updatedMedia);
      this.mediaWarmups.set(updatedMediaId, remoteWarmup);
    }.bind(this)).catch(function () {
      // A normal click will retry the request if an intent prefetch fails.
    });
  };

  prototype.previewVariantChoice = function (control) {
    var choice = this.getVariantChoice(control);
    if (!choice) return;

    var variantId = choice.dataset.variantId;
    if (variantId) this.syncVariantInput(variantId);

    var mediaId = choice.dataset.variantMediaId;
    var gallery = this.querySelector('media-gallery');
    var localMedia = mediaId && gallery && gallery.querySelector('.media-gallery__slide[data-media-id="' + mediaId + '"]');
    if (!localMedia) return;

    this.switchGalleryMedia(gallery, localMedia, gallery).catch(function () {
      // The server-rendered update remains the fallback for this selection.
    });
  };

  prototype.onMouseOver = function (event) {
    var label = event.target.closest('label');
    var control = label && label.querySelector('[data-product-hot-reload-trigger]');
    if (control) this.warmVariantChoice(control);
  };

  prototype.switchGalleryMedia = async function (gallery, updatedMedia, updatedGallery) {
    if (!gallery || !updatedMedia) return;

    var mediaId = updatedMedia.dataset.mediaId;
    var switchSequence = gallery.mediaSwitchSequence = (gallery.mediaSwitchSequence || 0) + 1;

    var slides = Array.from(gallery.querySelectorAll('.media-gallery__slide[data-media-id]'));
    var targetIndex = slides.findIndex(function (slide) {
      return String(slide.dataset.mediaId) === String(mediaId);
    });

    if (targetIndex < 0) {
      var activeSlide = gallery.querySelector('.media-gallery__slide--active');
      if (!activeSlide) return;

      var activeThumb = gallery.querySelector('.media-gallery__thumb--active');
      var updatedThumb = updatedGallery && updatedGallery.querySelector('.media-gallery__thumb--active');

      await this.preloadMediaImage(updatedMedia);
      if (switchSequence !== gallery.mediaSwitchSequence) return false;

      activeSlide.innerHTML = updatedMedia.innerHTML;
      activeSlide.dataset.mediaId = mediaId;
      activeSlide.dataset.mediaType = updatedMedia.dataset.mediaType || 'image';
      activeSlide.classList.remove('media-gallery__slide--is-animating');
      activeSlide.style.opacity = '';

      if (activeThumb && updatedThumb) {
        activeThumb.innerHTML = updatedThumb.innerHTML;
        activeThumb.dataset.mediaId = mediaId;
        activeThumb.dataset.mediaType = updatedThumb.dataset.mediaType || 'image';
      }

      return true;
    }

    var targetSlide = slides[targetIndex];
    var currentSlide = gallery.querySelector('.media-gallery__slide--active');
    if (targetSlide === currentSlide) return true;

    await this.preloadMediaImage(targetSlide);
    if (switchSequence !== gallery.mediaSwitchSequence) return false;

    this.hydrateSlideImage(targetSlide);

    if (gallery.variantSwitchTimer) {
      clearTimeout(gallery.variantSwitchTimer);
      gallery.variantSwitchTimer = null;
    }

    slides.forEach(function (slide) {
      var isTarget = slide === targetSlide;
      slide.classList.toggle('media-gallery__slide--active', isTarget);
      slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next', 'media-gallery__slide--is-animating');
      slide.style.transform = 'translateX(0)';
      slide.style.opacity = '';
    });

    gallery.querySelectorAll('.media-gallery__thumb').forEach(function (thumb) {
      var isTarget = String(thumb.dataset.mediaId) === String(mediaId) && thumb.style.display !== 'none';
      thumb.classList.toggle('media-gallery__thumb--active', isTarget);
    });

    if ('currentIndex' in gallery) gallery.currentIndex = targetIndex;

    return true;
  };

  prototype.updateVariantInPlace = async function (updatedRoot) {
    var previousVariantId = this.dataset.variantId;
    var updatedVariantId = updatedRoot.dataset.variantId;
    var previousPriceSignature = [this.dataset.variantPrice, this.dataset.variantCompareAtPrice].join(':');
    var updatedPriceSignature = [updatedRoot.dataset.variantPrice, updatedRoot.dataset.variantCompareAtPrice].join(':');
    var hasPriceMetadata = this.dataset.variantPrice && updatedRoot.dataset.variantPrice;

    this.syncVariantControls(updatedRoot);

    var currentGallery = this.querySelector('media-gallery');
    var updatedGallery = updatedRoot.querySelector('media-gallery');
    var updatedMedia = updatedGallery && updatedGallery.querySelector('.media-gallery__slide--active[data-media-id]');
    if (currentGallery && updatedMedia) {
      var mediaSwitched = await this.switchGalleryMedia(currentGallery, updatedMedia, updatedGallery);
      if (mediaSwitched === false) return false;
    }

    var priceBlockPattern = /__price(?:_|$)/i;
    var buyButtonsBlockPattern = /__buy(?:_buttons)?(?:_|$)/i;
    var dynamicBlockPattern = /__(?:.*_)?(?:installments|quantity(?:_picker)?|inventory|sku|pick(?:_|-)up)(?:_|$)/i;

    this.querySelectorAll('.shopify-block[id]').forEach(function (currentBlock) {
      if (currentBlock.querySelector('media-gallery')) return;
      if (currentBlock.querySelector('[data-product-hot-reload-trigger]')) return;

      var updatedBlock = updatedRoot.querySelector('[id="' + currentBlock.id + '"]');
      if (!updatedBlock || currentBlock.innerHTML === updatedBlock.innerHTML) return;

      if (priceBlockPattern.test(currentBlock.id)) {
        if (hasPriceMetadata && previousPriceSignature !== updatedPriceSignature) {
          this.syncElement(currentBlock, updatedBlock);
        }
        return;
      }

      if (buyButtonsBlockPattern.test(currentBlock.id)) {
        this.syncBuyButtons(currentBlock, updatedBlock);
        return;
      }

      var referencesPreviousVariant = previousVariantId && currentBlock.innerHTML.indexOf(previousVariantId) !== -1;
      if (dynamicBlockPattern.test(currentBlock.id) || referencesPreviousVariant) {
        currentBlock.innerHTML = updatedBlock.innerHTML;
      }
    }.bind(this));

    this.syncVariantInput(updatedVariantId);

    this.dataset.productUrl = updatedRoot.dataset.productUrl;
    this.dataset.variantId = updatedVariantId;
    this.dataset.variantPrice = updatedRoot.dataset.variantPrice;
    this.dataset.variantCompareAtPrice = updatedRoot.dataset.variantCompareAtPrice;

    document.dispatchEvent(new CustomEvent('theme:variant:change', {
      detail: { variantId: updatedVariantId }
    }));

    return true;
  };

  prototype.syncVariantInput = function (variantId) {
    if (!variantId) return;

    var productForms = Array.from(this.querySelectorAll('form[action*="/cart/add"]'));
    productForms.forEach(function (productForm) {
      var variantInputs = Array.from(productForm.querySelectorAll('input[name="id"]'));
      if (!variantInputs.length) {
        var variantInput = document.createElement('input');
        variantInput.type = 'hidden';
        variantInput.name = 'id';
        productForm.prepend(variantInput);
        variantInputs.push(variantInput);
      }

      variantInputs.forEach(function (variantInput) {
        var changed = String(variantInput.value) !== String(variantId);
        variantInput.value = variantId;
        variantInput.setAttribute('value', variantId);
        variantInput.disabled = false;

        if (changed) variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  };

  prototype.onVariantChange = async function (event) {
    if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

    var optionValueElement = event.target;
    var requestSequence = this.requestSequence = (this.requestSequence || 0) + 1;
    var requestUrl = this.buildRequestUrl(optionValueElement);
    var oldProductUrl = this.dataset.productUrl;
    var newProductUrl = oldProductUrl;

    if (optionValueElement.type === 'radio') {
      newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
    } else if (optionValueElement.tagName === 'SELECT') {
      var selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
      newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
    }

    this.previewVariantChoice(optionValueElement);

    this.showLoadingState();

    try {
      var html;
      html = await this.getVariantContent(optionValueElement);

      if (requestSequence !== this.requestSequence) return;
      await this.updateProductWithTransition(html, newProductUrl, optionValueElement.id);
    } catch (error) {
      console.error('Error updating product content:', error);
    } finally {
      if (requestSequence === this.requestSequence) this.hideLoadingState();
    }
  };

  prototype.updateProductWithTransition = async function (html, newProductUrl, targetId) {
    var updatedRoot = html.getElementById(this.id);
    if (!updatedRoot) throw new Error('Product section ' + this.id + ' was not found in the response');

    var isSameProduct = this.getProductPath(newProductUrl) === this.getProductPath(this.dataset.productUrl);
    if (!isSameProduct) return originalUpdate.call(this, html, newProductUrl, targetId);

    var variantUpdated = await this.updateVariantInPlace(updatedRoot);
    if (variantUpdated === false) return;

    var url = new URL(newProductUrl, window.location.origin);
    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.forEach(function (value, key) {
      if (key !== 'variant') url.searchParams.set(key, value);
    });
    url.searchParams.set('variant', this.dataset.variantId);
    window.history.replaceState({}, '', url.toString());

    var focusTarget = Array.from(this.querySelectorAll('[id]')).find(function (element) {
      return element.id === targetId;
    });
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  };

  document.querySelectorAll('product-hot-reload').forEach(function (root) {
    root.dataset.smoothVariantSwitch = 'true';
    root.onVariantChange = prototype.onVariantChange;
    root.syncVariantInput(root.dataset.variantId);
    if (root.dataset.smoothVariantBound) return;

    root.dataset.smoothVariantBound = 'true';
    root.addEventListener('change', function (event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;
      event.stopImmediatePropagation();
      prototype.onVariantChange.call(root, event);
    }, true);

    ['pointerdown', 'focusin'].forEach(function (eventName) {
      root.addEventListener(eventName, function (event) {
        var label = event.target.closest && event.target.closest('label');
        var control = label && label.querySelector('[data-product-hot-reload-trigger]');
        if (control) root.warmVariantChoice(control);
      }, { passive: true });
    });

    root.addEventListener('product-form:submit:before', function (event) {
      event.detail.form.set('id', root.dataset.variantId);
    });
  });
  }

  var ProductHotReload = window.customElements.get('product-hot-reload');
  if (ProductHotReload) {
    patchSmoothVariantSwitch();
  } else {
    window.customElements.whenDefined('product-hot-reload').then(patchSmoothVariantSwitch);
  }
})();
